import { render, staticRenderFns } from "./PatientMedicalCaseForm.vue?vue&type=template&id=437cd79c&scoped=true"
import script from "./PatientMedicalCaseForm.vue?vue&type=script&lang=js"
export * from "./PatientMedicalCaseForm.vue?vue&type=script&lang=js"
import style0 from "./PatientMedicalCaseForm.vue?vue&type=style&index=0&id=437cd79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437cd79c",
  null
  
)

export default component.exports